export default __webpack_public_path__ + "static/media/screenshot2.a4136f78.jpg";